// import React from "react";

// export const DetailBox = (props) => {
//   return (
//     <p
//       data-aos="fade-up  "
//       className={`details-text ${props.className}`}
//       style={props?.style}
//       dangerouslySetInnerHTML={{ __html: props.details }}
//     ></p>
//   );
// };

import React from "react";

export const DetailBox = ({
  details,
  children,
  className = "",
  style,
}) => {
  const isString = typeof details === "string";

  return (
    <p
      data-aos="fade-up"
      className={`details-text ${className}`}
      style={style}
    >
      {children
        ? children
        : isString
        ? <span dangerouslySetInnerHTML={{ __html: details }} />
        : details}
    </p>
  );
};
